import type {ReactElement} from 'react';
import React from 'react';
import {getCurrentPageBackground} from '@Components/poster-editor/poster-editor-reducer';
import {BaseItemBrightnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-brightness-option';
import {useAppSelector} from '@/hooks';
import {BackgroundTypeName} from '@PosterWhiteboard/page/background/background.types';

export function VideoBgBrightnessOption(): ReactElement<any> | null {
  const currentPageBackground = useAppSelector(getCurrentPageBackground);
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();

  if (!currentPageBackground) {
    return null;
  }

  if (currentPageBackground.details.type !== BackgroundTypeName.VIDEO) {
    return null;
  }

  const updateBrightness = (brightness: number, undoable = true): void => {
    void currentPage?.background.updateFromObject(
      {
        details: {
          videoBackgroundItemObject: {
            effects: {
              brightness,
            },
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemBrightnessOption brightness={currentPageBackground.details.videoBackgroundItemObject.effects.brightness} updateBrightness={updateBrightness} />;
}
